import SideBarContainer from 'Containers/SideBarContainer';
import ReportsLayout from 'Pages/reports/components/ReportsLayout/ReportsLayout';
import ReportsTitle from 'Pages/reports/components/ReportsTitle/ReportsTitle';
import { buildTime } from 'Pages/reports/utils/buildTime';
import { FaPeopleGroup } from 'react-icons/fa6';
import { MdSchool } from 'react-icons/md';
import { useHistoryCoursesReportPage } from './hooks/useHistoryCoursesReportPage';
import { Padding } from 'Components/Padding';
import ServerPaginatedTable from './components/ServerPaginatedTable/ServerPaginatedTable';
import HistoryCoursesFilters from './components/HistoryCoursesFilters/HistoryCoursesFilters';

export default function Page() {
  const {
    historyCoursesData,
    historyCoursesMeta,
    historyCoursesLoading,
    historyCoursesError,
    t2,
    handleSearch,
    handlePageChange,
    handleRowsPerPageChange,
    handleExport,
    handleRowClick,
  } = useHistoryCoursesReportPage();

  const buttons = [
    {
      icon: <FaPeopleGroup size={24} />,
      tooltip: t2('employees_report_tooltip'),
      route: '/reporte/historial/empleados',
    },
    { icon: <MdSchool size={24} />, tooltip: t2('courses_report_tooltip'), route: '/reporte/historial/cursos' },
  ];

  return (
    <SideBarContainer>
      <ReportsLayout
        title={<ReportsTitle title={t2('title')} accent={t2('title_accent')} />}
        buttons={buttons}
        onExport={handleExport}
      />
      <Padding padding="1rem">
        <HistoryCoursesFilters onSearch={handleSearch} />
        <Padding padding="0.5rem 0" />
        <ServerPaginatedTable
          columns={[
            { id: 'name', label: t2('course_name') },
            { id: 'priority', label: t2('priority') },
            { id: 'category', label: t2('category') },
            { id: 'totalTrainingHours', label: t2('total_completions'), align: 'center' },
          ]}
          rows={historyCoursesData.map(item => ({
            id: item.id,
            name: item.name,
            priority: item.priority?.name || '-',
            category: item.category?.name || '-',
            totalTrainingHours: buildTime(parseFloat(item.totalTrainingHours || '0'), t2),
          }))}
          meta={historyCoursesMeta}
          loading={historyCoursesLoading}
          error={historyCoursesError}
          onPageChange={handlePageChange}
          onRowsPerPageChange={handleRowsPerPageChange}
          onRowClick={handleRowClick}
        />
      </Padding>
    </SideBarContainer>
  );
}
